module.exports = __webpack_public_path__ + "static/Nunito-Bold-6f47bcfc065790f02ed3cb8b51bef56f.ttf";